import {
  getMSFilterSwitchYesNoToggleButtonSx,
  getMSFilterSwitchYesNoToggleButtonWidth,
} from "@pages/managed-accounts/model-screener/components/model-screener-table/toolbar/filter/filter-item/switch-yes-no/utils";
import { SxProps, Theme } from "@mui/material";

export const getMSFilterSwitchSelectToggleButtonSx =
  getMSFilterSwitchYesNoToggleButtonSx;

export const getMSFilterSwitchSelectFormControlLabelSx = ({
  isSmallSize,
}: {
  isSmallSize: boolean;
}): SxProps<Theme> => ({
  ".MuiTypography-root": {
    fontSize: isSmallSize ? 10 : 13,
    fontWeight: 500,
    p: isSmallSize ? 0 : undefined,
  },
  ".MuiFormControlLabel-label": {
    div: {
      paddingTop: isSmallSize ? "2px !important" : "0px !important",
      textAlign: "start",
    },
  },
  marginTop: 0,
  alignItems: "center",
});

export const getMSFilterSwitchSelectToggleButtonWidth =
  getMSFilterSwitchYesNoToggleButtonWidth;
